// inventory SKU 連動対象の photo_tour_id のリスト。
// このツアーのみ「設置は未完了」オプションを表示する。
export const INVENTORY_LINKED_PHOTO_TOUR_IDS =
    process.env.NODE_ENV !== "production"
        ? // 開発環境
          ["670dc090-e8a3-41a7-be48-d897179f3d89"]
        : // 本番環境
          ["500eab19-2081-4062-bc09-49f9489a4932"]
